import ListQuestions from './ListQuestions'

export default ListQuestions
